import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-actionbuttons-column-renderer',
  template: ` <a [routerLink]="fnLink(params)" [target]="target">{{ params.value }}</a> `,
  standalone: false
})
export class LinkColumnRendererComponent implements AgRendererComponent {
  public params: any
  public target = '_self'
  public fnLink: (p: any) => string[]

  agInit(params: any): void {
    this.params = params
    this.fnLink = params.context.fnLink
    this.target = !!params.context.fnLinkTargetNew ? '_blank' : '_self'
  }

  refresh(params: any): boolean {
    return false
  }
}
